import routerABI from "../abi/router.json";
import panCakeAbi from "../abi/rezor.json";
import factoryABI from "../abi/factory.json";
import quoteABI from "../abi/quote.json";
import uniswapv3ABI from "../abi/uniswapv3.json";
import pairABI from "../abi/pair.json";
import stakingABI from "../abi/stakingFactory.json";
import BlueSparrow from "../icons/blue-sparrow.svg";
import BNB from "../icons/tokens/bnb.svg";
import BONE from "../icons/bone.svg";
import BUSD from "../icons/USDT.svg";
import CRO from "../icons/crocro.svg";
import DOGE from "../icons/dogecoin-logo.svg";
import DUBX from "../icons/dubx.svg";
import ETH from "../icons/ETH-Token.svg";
import FUND from "../icons/fund.svg";
import SLAKE from "../icons/slake.svg";
import iRYDE from "../icons/iryde.svg";
import Jasmy from "../icons/jasmy.svg";
import Kishimoto from "../icons/Automata.svg";
import LUNAC from "../icons/Lunac.svg";
import MANDOX from "../icons/Audius.svg";
import MAZI from "../icons/mazi.svg";
import { TOKEN_DATA } from "../../interfaces/Liquidity";
import motionToken from "../icons/MOTN.svg";
import MAGA from "../icons/latestTruMaga.svg";
import BDEFI from "../icons/BDEFI.svg";
import FOF from "../icons/FOFIconNewSmall.svg";

export const envType: string = process.env.REACT_APP_ENV_TYPE || "production";
// export const envType: string = process.env.REACT_APP_ENV_TYPE || "stage";




export const BSC_CONTRACT_LIST =
  envType !== "production"
    ? {
      router: {
        address: "0xbB22f3800873222122fe6F5df88cDeC41fDA95e2",
        Block: 6615558,
        abi: routerABI,
      },
      panCakeSwap: {
        address: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
        blockNumber: 6810080,
        abi: routerABI,
      },
      factory: {
        address: "0x865ba7E55909b55Dfb24879DA91cFBE0af04ACC8",
        blockNumber: 6430279,
        abi: factoryABI,
      },
      panRouter: {
        address: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        Block: 6615558,
        abi: routerABI,
      },
      panCakeRouter: {
        address: "0x744A4c9c9F40A443ac2A5747D4f3b773e5d86763",
        blockNumber: 6810080,
        abi: routerABI,
      },
      // panCake: {
      //   address: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      //   blockNumber: 6810080,
      //   abi: routerABI,
      // },
      pair: {
        address: "",
        blockNumber: 0,
        abi: pairABI,
      },
      stakingFactory: {
        address: "0xA396Cf2A1b8393DbAC0369fFBecA1C0FA251A413",
        blockNumber: 0,
        abi: stakingABI,
      },
    }
    : {
      router: {
        address: "0x4D412972f4fCe736F1E5a1425De7495419a4CBa4",
        Block: 6615558,
        abi: routerABI,
      },
      panCakeSwap: {
        address: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        blockNumber: 6810080,
        abi: routerABI,
      },
      uniswap: {
        address: "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24",
        blockNumber: 6810080,
        abi: routerABI,
      },
      quote: {
        address: "0x78D78E420Da98ad378D7799bE8f4AF69033EB077",
        Block: 6615558,
        abi: quoteABI,
      },
      uniswapv3: {
        address: "0xB971eF87ede563556b2ED4b1C0b0019111Dd85d2",
        Block: 6615558,
        abi: uniswapv3ABI,
      },
      factory: {
        address: "0x3D36c450fDbFB4E483D9E9Cf44f78989dEA429B0",
        blockNumber: 6430279,
        abi: factoryABI,
      },
      panRouter: {
        address: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        Block: 6615558,
        abi: routerABI,
      },
      // router: {
      //   address: "0x9aAC13697a077B23Af8826789AF7B9fdBd13111f",
      //   Block: 6615558,
      //   abi: routerABI,  
      // },
      panCakeRouter: {
        address: "0x9aAC13697a077B23Af8826789AF7B9fdBd13111f",
        blockNumber: 6810080,
        abi: routerABI,
      },
      panCake: {
        address: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
        blockNumber: 6810080,
        abi: panCakeAbi,
      },
      // factory: {
      //   address: "0x6a6DeA0cd52689819eb3Bf2c15594Beafb646CB7",
      //   blockNumber: 6430279,
      //   abi: factoryABI,
      // },
      pair: {
        address: "",
        blockNumber: 0,
        abi: pairABI,
      },
      stakingFactory: {
        address: "0x55aAe309FC26820c825254cB9b93b94Cb46d99CC",
        blockNumber: 0,
        abi: stakingABI,
      },
    };

export const ETHEREUM_CONTRACT_LIST =
  envType !== "production"
    ? {
      router: {
        address: "0x243764Bd2fD0701C2D540928b5e53f8639904273",
        Block: 15210794,
        abi: routerABI,
      },
      panCakeRouter: {
        address: "0x6318E55bdFE7B6d153C7fAAd43B09C5aE47CC770",
        blockNumber: 15210794,
        abi: routerABI,
      },
      factory: {
        address: "0xa4EC53193468a246e799c8657E927313c079E1E4",
        blockNumber: 6430279,
        abi: factoryABI,
      },
      pair: {
        address: "",
        blockNumber: 0,
        abi: pairABI,
      },
      stakingFactory: {
        address: "0x17fA956c56B4751a9A447a124A7b4d256773E556",
        blockNumber: 0,
        abi: stakingABI,
      },
    }
    : {
      panRouter: {
        address: "0xEfF92A263d31888d860bD50809A8D171709b7b1c",
        Block: 15210794,
        abi: routerABI,
      },
      router: {
        address: "0x549EFb3c8365F3f222aaA44D9af7894CdAfFF083",
        Block: 15210794,
        abi: routerABI,
      },
      panCakeRouter: {
        address: "0x549EFb3c8365F3f222aaA44D9af7894CdAfFF083",
        blockNumber: 15210794,
        abi: routerABI,
      },
      factory: {
        address: "0x25393bb68c89a894b5e20fa3fc3b3b34f843c672",
        blockNumber: 6430279,
        abi: factoryABI,
      },
      pair: {
        address: "",
        blockNumber: 0,
        abi: pairABI,
      },
      stakingFactory: {
        address: "0x461aDA809CeD50ebA546877D29Ca0CD2230098B2",
        blockNumber: 0,
        abi: stakingABI,
      },
    };


export const BSC_TOKEN_LIST: TOKEN_DATA[] =
  envType !== "production"
    ? [
      {
        name: "BNB",
        address: "0xfDd1a163518E7ee5e98b60c87E93e2881dbFfCd0",
        isNative: true,
        decimals: 18,
        symbol: "BNB",
        chainId: 97,
        icon: BNB,
      },
      {
        name: "Mazimatic",
        address: "0xcC12487954C2b0deA99F8f0b6Bf2Edd13779075a",
        isNative: false,
        decimals: 18,
        symbol: "MAZI",
        chainId: 97,
        icon: MAZI,
      },
      {
        name: "USDT",
        address: "0x06251D86D2EB6a67323014C1ED7b94422AFC5349",
        isNative: false,
        decimals: 18,
        symbol: "USDT",
        chainId: 97,
        icon: BUSD,
      },
      {
        name: "DogeCoin",
        address: "0x3Fea0Ca76Ac13D41C784f4AF6898479dfA8BBDd3",
        isNative: false,
        decimals: 8,
        symbol: "DOGE",
        chainId: 97,
        icon: DOGE,
      },
    ]
    : [
      {
        name: "BNB",
        address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        isNative: true,
        decimals: 18,
        symbol: "BNB",
        chainId: 56,
        icon: BNB,
      },
      {
        name: "Mazimatic",
        address: "0x5B8650Cd999B23cF39Ab12e3213fbC8709c7f5CB",
        isNative: false,
        decimals: 18,
        symbol: "MAZI",
        chainId: 56,
        icon: MAZI,
      },
      {
        name: "TruMaga",
        address: "0x328Ea6e5Ba4cc4B58799F2AEC3d8BA839f4314Ba",
        isNative: false,
        decimals: 18,
        symbol: "TruMaga",
        chainId: 56,
        icon: MAGA,
      },
      {
        name: "Blokdefi",
        address: "0xE078118Fd1EC3E96750ab30bb32bB7aaF95d42D4",
        isNative: false,
        decimals: 18,
        symbol: "BDEFI",
        chainId: 56,
        icon: BDEFI,
      },
      {
        name: "Flame Of Floki",
        address: "0xf0fcf7602c4722ad4cbc1b1d8bf8b3a79ee4c8e1",
        isNative: false,
        decimals: 18,
        symbol: "FOF",
        chainId: 56,
        icon: FOF,
      },
      {
        name: "USDT",
        address: "0x55d398326f99059fF775485246999027B3197955",
        isNative: false,
        decimals: 18,
        symbol: "USDT",
        chainId: 56,
        icon: BUSD,
      },
      {
        name: "MotionToken",
        address: "0x5dEF381F3A069ECD90AE69361F61d96Bd9f3Ad70",
        isNative: false,
        decimals: 18,
        symbol: "MOTN",
        chainId: 56,
        icon: motionToken,
      },
      {
        name: "DogeCoin",
        address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
        isNative: false,
        decimals: 8,
        symbol: "DOGE",
        chainId: 56,
        icon: DOGE,
      },
    ];





export const ETHEREUM_TOKEN_LIST: TOKEN_DATA[] =
  envType !== "production"
    ? [
      {
        name: "ETH",
        address: "0xC8d8Ad6092aA5929E521f81114615b113460dE27",
        isNative: true,
        decimals: 18,
        symbol: "ETH",
        chainId: 1,
        icon: ETH,
      },
      {
        name: "Kishimoto",
        address: "0xae36155a55f04a696b8362777620027882b31db5",
        isNative: false,
        decimals: 9,
        symbol: "Kishimoto",
        chainId: 1,
        icon: Kishimoto,
      },
      {
        name: "Slake",
        address: "0x9C2500CfD2f1De40255Cee5EC8AdA6466E1eddf1",
        isNative: false,
        decimals: 18,
        symbol: "SLAKE",
        chainId: 1,
        icon: SLAKE,
      },
      {
        name: "FUND",
        address: "0xe9B076B476D8865cDF79D1Cf7DF420EE397a7f75",
        isNative: false,
        decimals: 9,
        symbol: "Unification(FUND)",
        chainId: 1,
        icon: FUND,
      },
      {
        name: "Mandox",
        address: "0x33d203fa03bb30b133de0fe2d6533c268ba286b6",
        isNative: false,
        decimals: 9,
        symbol: "MANDOX",
        chainId: 1,
        icon: MANDOX,
      },
      {
        name: "Bone",
        address: "0x9813037ee2218799597d83D4a5B6F3b6778218d9",
        isNative: false,
        decimals: 18,
        symbol: "BONE",
        chainId: 1,
        icon: BONE,
      },
      {
        name: "BlueSparrow Token",
        address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
        isNative: false,
        decimals: 9,
        symbol: "BlueSparrow",
        chainId: 1,
        icon: BlueSparrow,
      },
      {
        name: "Cronos",
        address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
        isNative: false,
        decimals: 8,
        symbol: "CRO",
        chainId: 1,
        icon: CRO,
      },
      {
        name: "JasmyCoin",
        address: "0x7420b4b9a0110cdc71fb720908340c03f9bc03ec",
        isNative: false,
        decimals: 18,
        symbol: "JASMY",
        chainId: 1,
        icon: Jasmy,
      },
      {
        name: "LUNA Classic",
        address: "0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9",
        isNative: false,
        decimals: 18,
        symbol: "LUNC",
        chainId: 1,
        icon: LUNAC,
      },
      {
        name: "iRYDE",
        address: "0x74fE27e70db10147F8B6b38b3C9d12BBdcf3b5AF",
        isNative: false,
        decimals: 18,
        symbol: "iRYDE",
        chainId: 1,
        icon: iRYDE,
      },
      {
        name: "DUBX",
        address: "0x75CE16D11B83605aa039D40d7d846ff23064Fb65",
        isNative: false,
        decimals: 9,
        symbol: "DUB",
        chainId: 1,
        icon: DUBX,
      },
    ]
    : [
      {
        name: "ETH",
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        isNative: true,
        decimals: 18,
        symbol: "ETH",
        chainId: 1,
        icon: ETH,
      },
      {
        name: "Kishimoto",
        address: "0xae36155a55f04a696b8362777620027882b31db5",
        isNative: false,
        decimals: 9,
        symbol: "Kishimoto",
        chainId: 1,
        icon: Kishimoto,
      },
      {
        name: "Slake",
        address: "0x9C2500CfD2f1De40255Cee5EC8AdA6466E1eddf1",
        isNative: false,
        decimals: 18,
        symbol: "SLAKE",
        chainId: 1,
        icon: SLAKE,
      },
      // {
      //   name: "FUND",
      //   address: "0xe9B076B476D8865cDF79D1Cf7DF420EE397a7f75",
      //   isNative: false,
      //   decimals: 9,
      //   symbol: "Unification(FUND)",
      //  chainId:1,
      // icon: FUND,
      // },
      {
        name: "Mandox",
        address: "0x33d203fa03bb30b133de0fe2d6533c268ba286b6",
        isNative: false,
        decimals: 9,
        symbol: "MANDOX",
        chainId: 1,
        icon: MANDOX,
      },
      // {
      //   name: "Bone",
      //   address: "0x9813037ee2218799597d83D4a5B6F3b6778218d9",
      //   isNative: false,
      //   decimals: 18,
      //   symbol: "BONE",
      //  chainId:1,
      // icon: BONE,
      // },
      {
        name: "BlueSparrow Token",
        address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
        isNative: false,
        decimals: 9,
        symbol: "BlueSparrow",
        chainId: 1,
        icon: BlueSparrow,
      },
      // {
      //   name: "Cronos",
      //   address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
      //   isNative: false,
      //   decimals: 8,
      //   symbol: "CRO",
      //  chainId:1,
      // icon: CRO,
      // },
      // {
      //   name: "JasmyCoin",
      //   address: "0x7420b4b9a0110cdc71fb720908340c03f9bc03ec",
      //   isNative: false,
      //   decimals: 18,
      //   symbol: "JASMY",
      //  chainId:1,
      // icon: Jasmy,
      // },
      // {
      //   name: "LUNA Classic",
      //   address: "0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9",
      //   isNative: false,
      //   decimals: 18,
      //   symbol: "LUNC",
      //  chainId:1,
      // icon: LUNAC,
      // },
      {
        name: "iRYDE",
        address: "0x74fE27e70db10147F8B6b38b3C9d12BBdcf3b5AF",
        isNative: false,
        decimals: 18,
        symbol: "iRYDE",
        chainId: 1,
        icon: iRYDE,
      },
      {
        name: "DUBX",
        address: "0x75CE16D11B83605aa039D40d7d846ff23064Fb65",
        isNative: false,
        decimals: 9,
        symbol: "DUB",
        chainId: 1,
        icon: DUBX,
      },
    ];

export const REZOR_TOKEN_LIST: TOKEN_DATA[] =
  [
    {
      name: "BNB",
      address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
      isNative: true,
      decimals: 18,
      symbol: "BNB",
      chainId: 56, 
      icon:BNB,
    },

    {
      name: "USDC",
      address: "0x6e4BB331Fd5fd9d7d9Cb7De52C2426ED861d5302",
      isNative: false,
      decimals: 6,
      symbol: "USDC",
      chainId: 56,
      icon: BUSD,
    },
    {
      name: "DogeCoin",
      address: "0xA5d77349db339eaC3E0AC749A03fde07653CC00B",
      isNative: false,
      decimals: 8,
      symbol: "DOGE",
      chainId: 56,
      icon: DOGE,
    },
    {
      name: "USDT",
      address: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
      isNative: false,
      decimals: 18,
      symbol: "USDT",
      chainId: 56,
      icon: BUSD,
    },
  ];

export const PANCAKE_TOKEN_LIST: TOKEN_DATA[] =
  envType !== "production"
    ? [
      // {
      //   name: "BNB",
      //   address: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      //   isNative: true,
      //   decimals: 18,
      //   symbol: "BNB",
      //  chainId:1,
      // icon: BNB,
      // },
      {
        name: "BNB",
        address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
        isNative: true,
        decimals: 18,
        symbol: "BNB",
        chainId: 97,
        icon: BNB,
      },

      {
        name: "USDC",
        address: "0x6e4BB331Fd5fd9d7d9Cb7De52C2426ED861d5302",
        isNative: false,
        decimals: 6,
        symbol: "USDC",
        chainId: 97,
        icon: BUSD,
      },
      {
        name: "DogeCoin",
        address: "0xA5d77349db339eaC3E0AC749A03fde07653CC00B",
        isNative: false,
        decimals: 8,
        symbol: "DOGE",
        chainId: 97,
        icon: DOGE,
      },
      {
        name: "USDT",
        address: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
        isNative: false,
        decimals: 18,
        symbol: "USDT",
        chainId: 97,
        icon: BUSD,
      }
    ]
    : [
      {
        name: "BNB",
        address: "0x0000000000000000000000000000000000000000",
        isNative: true,
        decimals: 18,
        symbol: "BNB",
        chainId: 56,
        icon: BNB,
      },
      {
        name: "USDC",
        address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        isNative: false,
        decimals: 18,
        symbol: "USDC",
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d.png",
      },
      {
        name: "USDT",
        address: "0x55d398326f99059fF775485246999027B3197955",
        isNative: false,
        decimals: 18,
        symbol: "USDT",
        chainId: 56,
        icon: BUSD,
      },
      {
        name: "DogeCoin",
        address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
        isNative: false,
        decimals: 8,
        symbol: "DOGE",
        chainId: 56,
        icon: DOGE,
      },
      {
        name: "Cardano Token",
        symbol: "ADA",
        address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47.png",
      },
      {
        name: "ALICE",
        symbol: "ALICE",
        address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
        isNative: false,
        decimals: 6,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xAC51066d7bEC65Dc4589368da368b212745d63E8.png",
      },
      {
        name: "AlinX",
        symbol: "ALIX",
        address: "0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xaF6Bd11A6F8f9c44b9D18f5FA116E403db599f8E/logo.png",
      },
      {
        name: "AlphaToken",
        symbol: "ALPHA",
        address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xa1faa113cbE53436Df28FF0aEe54275c13B40975.png",
      },
      {
        name: "Altura",
        symbol: "ALU",
        address: "0x8263CD1601FE73C066bf49cc09841f35348e3be0",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8263CD1601FE73C066bf49cc09841f35348e3be0/logo.png",
      },
      {
        name: "Automata",
        symbol: "ATA",
        address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xA2120b9e674d3fC3875f415A7DF52e382F141225.png",
      },
      {
        name: "Cosmos Token",
        symbol: "ATOM",
        address: "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x0Eb3a705fc54725037CC9e008bDede697f62F335.png",
      },
      {
        name: "Axie Infinity Shard",
        symbol: "AXS",
        address: "0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0.png",
      },
      {
        name: "WBNB",
        address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        isNative: true,
        decimals: 18,
        symbol: "WBNB",
        chainId: 56,
        icon: BNB,
      },
      {
        name: "Baby Doge Coin",
        symbol: "BABYDOGE",
        address: "0xc748673057861a797275CD8A068AbB95A902e8de",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc748673057861a797275CD8A068AbB95A902e8de/logo.png",
      },
      {
        name: "Bear",
        symbol: "BEAR",
        address: "0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc3EAE9b061Aa0e1B9BD3436080Dc57D2d63FEdc1/logo.png",
      },
      {
        name: "Bella Protocol",
        symbol: "BEL",
        address: "0x8443f091997f06a61670B735ED92734F5628692F",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x8443f091997f06a61670B735ED92734F5628692F.png",
      },
      {
        name: "BELT Token",
        symbol: "BELT",
        address: "0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f.png",
      },
      {
        name: "Binemon",
        symbol: "BIN",
        address: "0xe56842Ed550Ff2794F010738554db45E60730371",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xe56842Ed550Ff2794F010738554db45E60730371/logo.png",
      },
      {
        name: "Binamon",
        symbol: "BMON",
        address: "0x08ba0619b1e7A582E0BCe5BBE9843322C954C340",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x08ba0619b1e7A582E0BCe5BBE9843322C954C340.png",
      },
      {
        name: "BinaryX",
        symbol: "BNX",
        address: "0x8C851d1a123Ff703BD1f9dabe631b69902Df5f97",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8C851d1a123Ff703BD1f9dabe631b69902Df5f97/logo.png",
      },
      {
        name: "BunnyPark",
        symbol: "BP",
        address: "0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1.png",
      },
      {
        name: "BSCPAD.com",
        symbol: "BSCPAD",
        address: "0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700.png",
      },
      {
        name: "BitTorrent Old",
        symbol: "BTTOLD",
        address: "0x8595F9dA7b868b1822194fAEd312235E43007b49",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x8595F9dA7b868b1822194fAEd312235E43007b49.png",
      },
      {
        name: "Coin98",
        symbol: "C98",
        address: "0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6.png",
      },
      {
        name: "Chess",
        symbol: "CHESS",
        address: "0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6.png",
      },
      {
        name: "Chroma",
        symbol: "CHR",
        address: "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
        isNative: false,
        decimals: 6,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE.png",
      },
      {
        name: "CP",
        symbol: "CP",
        address: "0x82C19905B036bf4E329740989DCF6aE441AE26c1",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x82C19905B036bf4E329740989DCF6aE441AE26c1/logo.png",
      },
      {
        name: "DeRace Token",
        symbol: "DERC",
        address: "0x373E768f79c820aA441540d254dCA6d045c6d25b",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x373E768f79c820aA441540d254dCA6d045c6d25b/logo.png",
      },
      {
        name: "DODO bird",
        symbol: "DODO",
        address: "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2.png",
      },
      {
        name: "Dogecoin",
        symbol: "DOGE",
        address: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
        isNative: false,
        decimals: 8,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xbA2aE424d960c26247Dd6c32edC70B295c744C43.png",
      },
      {
        name: "My DeFi Pet Token",
        symbol: "DPET",
        address: "0xfb62AE373acA027177D1c18Ee0862817f9080d08",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xfb62AE373acA027177D1c18Ee0862817f9080d08/logo.png",
      },
      {
        name: "DeathRoad Token",
        symbol: "DRACE",
        address: "0xA6c897CaaCA3Db7fD6e2D2cE1a00744f40aB87Bb",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA6c897CaaCA3Db7fD6e2D2cE1a00744f40aB87Bb/logo.png",
      },
      {
        name: "DragonSlayer",
        symbol: "DRS",
        address: "0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc8E8ecB2A5B5d1eCFf007BF74d15A86434aA0c5C/logo.png",
      },
      {
        name: "Dvision",
        symbol: "DVI",
        address: "0x758FB037A375F17c7e195CC634D77dA4F554255B",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x758FB037A375F17c7e195CC634D77dA4F554255B.png",
      },
      {
        name: "Etherconnect Coin",
        symbol: "ECC",
        address: "0x8D047F4F57A190C96c8b9704B39A1379E999D82B",
        isNative: false,
        decimals: 8,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8D047F4F57A190C96c8b9704B39A1379E999D82B/logo.png",
      },
      {
        name: "Ellipsis",
        symbol: "EPS",
        address: "0xA7f552078dcC247C2684336020c03648500C6d9F",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xA7f552078dcC247C2684336020c03648500C6d9F.png",
      },
      {
        name: "FaraCrystal",
        symbol: "FARA",
        address: "0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1/logo.png",
      },
      {
        name: "FLOKI",
        symbol: "FLOKI",
        address: "0x2B3F34e9D4b127797CE6244Ea341a83733ddd6E4",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x2B3F34e9D4b127797CE6244Ea341a83733ddd6E4/logo.png",
      },
      {
        name: "Formation Finance",
        symbol: "FORM",
        address: "0x25A528af62e56512A19ce8c3cAB427807c28CC19",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x25A528af62e56512A19ce8c3cAB427807c28CC19.png",
      },
      {
        name: "Frontier Token",
        symbol: "FRONT",
        address: "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b.png",
      },
      {
        name: "CyberDragon Gold",
        symbol: "GOLD",
        address: "0xb3a6381070B1a15169DEA646166EC0699fDAeA79",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xb3a6381070B1a15169DEA646166EC0699fDAeA79/logo.png",
      },
      {
        name: "StepHero",
        symbol: "HERO",
        address: "0xE8176d414560cFE1Bf82Fd73B986823B89E4F545",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xE8176d414560cFE1Bf82Fd73B986823B89E4F545.png",
      },
      {
        name: "Metahero",
        symbol: "HERO",
        address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13.png",
      },
      {
        name: "Honey token",
        symbol: "HONEY",
        address: "0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5/logo.png",
      },
      {
        name: "Hunny Token",
        symbol: "HUNNY",
        address: "0x565b72163f17849832A692A3c5928cc502f46D69",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x565b72163f17849832A692A3c5928cc502f46D69/logo.png",
      },
      {
        name: "Injective Protocol",
        symbol: "INJ",
        address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xa2B726B1145A4773F68593CF171187d8EBe4d495.png",
      },
      {
        name: "IoTeX Network",
        symbol: "IOTX",
        address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x9678E42ceBEb63F23197D726B29b1CB20d0064E5.png",
      },
      {
        name: "Kaby Arena",
        symbol: "KABY",
        address: "0x02A40C048eE2607B5f5606e445CFc3633Fb20b58",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x02A40C048eE2607B5f5606e445CFc3633Fb20b58/logo.png",
      },
      {
        name: "KmonCoin",
        symbol: "KMON",
        address: "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xc732B6586A93b6B7CF5FeD3470808Bc74998224D/logo.png",
      },
      {
        name: "Linear Token",
        symbol: "LINA",
        address: "0x762539b45A1dCcE3D36d080F74d1AED37844b878",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x762539b45A1dCcE3D36d080F74d1AED37844b878.png",
      },
      {
        name: "ChainLink Token",
        symbol: "LINK",
        address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD.png",
      },
      {
        name: "Mask Network",
        symbol: "MASK",
        address: "0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3.png",
      },
      {
        name: "Mobox",
        symbol: "MBOX",
        address: "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377.png",
      },
      {
        name: "MiniFootball",
        symbol: "MINIFOOTBALL",
        address: "0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD024Ac1195762F6F13f8CfDF3cdd2c97b33B248b/logo.png",
      },
      {
        name: "Mist",
        symbol: "MIST",
        address: "0x68E374F856bF25468D365E539b700b648Bf94B67",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x68E374F856bF25468D365E539b700b648Bf94B67/logo.png",
      },
      {
        name: "Mound Token",
        symbol: "MND",
        address: "0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4c97c901B5147F8C1C7Ce3c5cF3eB83B44F244fE/logo.png",
      },
      {
        name: "Monsta Infinite Token",
        symbol: "MONI",
        address: "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9573c88aE3e37508f87649f87c4dd5373C9F31e0/logo.png",
      },
      {
        name: "Nafter",
        symbol: "NAFT",
        address: "0xD7730681B1DC8f6F969166B29D8A5EA8568616a3",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD7730681B1DC8f6F969166B29D8A5EA8568616a3/logo.png",
      },
      {
        name: "Nobility",
        symbol: "NBL",
        address: "0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA67a13c9283Da5AABB199Da54a9Cb4cD8B9b16bA/logo.png",
      },
      {
        name: "NFTB",
        symbol: "NFTB",
        address: "0xde3dbBE30cfa9F437b293294d1fD64B26045C71A",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xde3dbBE30cfa9F437b293294d1fD64B26045C71A/logo.png",
      },
      {
        name: "Nerve",
        symbol: "NRV",
        address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096.png",
      },
      {
        name: "Harmony ONE",
        symbol: "ONE",
        address: "0x03fF0ff224f904be3118461335064bB48Df47938",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x03fF0ff224f904be3118461335064bB48Df47938.png",
      },
      {
        name: "PAID Network",
        symbol: "PAID",
        address: "0xAD86d0E9764ba90DDD68747D64BFfBd79879a238",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAD86d0E9764ba90DDD68747D64BFfBd79879a238/logo.png",
      },
      {
        name: "PET GAMES",
        symbol: "PETG",
        address: "0x09607078980CbB0665ABa9c6D1B84b8eAD246aA0",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x09607078980CbB0665ABa9c6D1B84b8eAD246aA0/logo.png",
      },
      {
        name: "Pink Token",
        symbol: "PINK",
        address: "0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9133049Fb1FdDC110c92BF5b7Df635abB70C89DC/logo.png",
      },
      {
        name: "Polkamon",
        symbol: "PMON",
        address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2.png",
      },
      {
        name: "Poco Token",
        symbol: "POCO",
        address: "0x394bBA8F309f3462b31238B3fd04b83F71A98848",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x394bBA8F309f3462b31238B3fd04b83F71A98848/logo.png",
      },
      {
        name: "Moonpot",
        symbol: "POTS",
        address: "0x3Fcca8648651E5b974DD6d3e50F61567779772A8",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x3Fcca8648651E5b974DD6d3e50F61567779772A8.png",
      },
      {
        name: "Plant vs Undead Token",
        symbol: "PVU",
        address: "0x31471E0791fCdbE82fbF4C44943255e923F1b794",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x31471E0791fCdbE82fbF4C44943255e923F1b794/logo.png",
      },
      {
        name: "PandaInu Wallet Token",
        symbol: "PWT",
        address: "0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2",
        isNative: false,
        decimals: 8,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xf3eDD4f14a018df4b6f02Bf1b2cF17A8120519A2/logo.png",
      },
      {
        name: "Qubit Token",
        symbol: "QBT",
        address: "0x17B7163cf1Dbd286E262ddc68b553D899B93f526",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x17B7163cf1Dbd286E262ddc68b553D899B93f526.png",
      },
      {
        name: "Radio Caca V2",
        symbol: "RACA",
        address: "0x12BB890508c125661E03b09EC06E404bc9289040",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x12BB890508c125661E03b09EC06E404bc9289040/logo.png",
      },
      {
        name: "RAMP DEFI",
        symbol: "RAMP",
        address: "0x8519EA49c997f50cefFa444d240fB655e89248Aa",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x8519EA49c997f50cefFa444d240fB655e89248Aa.png",
      },
      {
        name: "Reef.finance",
        symbol: "REEF",
        address: "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e.png",
      },
      {
        name: "rUSD",
        symbol: "RUSD",
        address: "0x07663837218A003e66310a01596af4bf4e44623D",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x07663837218A003e66310a01596af4bf4e44623D.png",
      },
      {
        name: "SafePal Token",
        symbol: "SFP",
        address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb.png",
      },
      {
        name: "SeedifyFund",
        symbol: "SFUND",
        address: "0x477bC8d23c634C154061869478bce96BE6045D12",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x477bC8d23c634C154061869478bce96BE6045D12.png",
      },
      {
        name: "Shirtum",
        symbol: "SHI",
        address: "0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7269d98Af4aA705e0B1A5D8512FadB4d45817d5a/logo.png",
      },
      {
        name: "CryptoBlades Skill Token",
        symbol: "SKILL",
        address: "0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab.png",
      },
      {
        name: "StarMon",
        symbol: "SMON",
        address: "0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAB15B79880f11cFfb58dB25eC2bc39d28c4d80d2/logo.png",
      },
      {
        name: "Splintershards",
        symbol: "SPS",
        address: "0x1633b7157e7638C4d6593436111Bf125Ee74703F",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x1633b7157e7638C4d6593436111Bf125Ee74703F.png",
      },
      {
        name: "SushiToken",
        symbol: "SUSHI",
        address: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x947950BcC74888a40Ffa2593C5798F11Fc9124C4.png",
      },
      {
        name: "Swipe",
        symbol: "SXP",
        address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A.png",
      },
      {
        name: "Tokocrypto Token",
        symbol: "TKO",
        address: "0x9f589e3eabe42ebC94A44727b3f3531C0c877809",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x9f589e3eabe42ebC94A44727b3f3531C0c877809.png",
      },
      {
        name: "Alien Worlds Trilium",
        symbol: "TLM",
        address: "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
        isNative: false,
        decimals: 4,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x2222227E22102Fe3322098e4CBfE18cFebD57c95.png",
      },
      {
        name: "TokenPocket Token",
        symbol: "TPT",
        address: "0xECa41281c24451168a37211F0bc2b8645AF45092",
        isNative: false,
        decimals: 4,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xECa41281c24451168a37211F0bc2b8645AF45092.png",
      },
      {
        name: "TRONPAD.network",
        symbol: "TRONPAD",
        address: "0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x1Bf7AedeC439D6BFE38f8f9b20CF3dc99e3571C4/logo.png",
      },
      {
        name: "TRON",
        symbol: "TRX",
        address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B.png",
      },
      {
        name: "TrusterCoin",
        symbol: "TSC",
        address: "0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA2a26349448ddAfAe34949a6Cc2cEcF78c0497aC/logo.png",
      },
      {
        name: "TrueUSD",
        symbol: "TUSD",
        address: "0x14016E85a25aeb13065688cAFB43044C2ef86784",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x14016E85a25aeb13065688cAFB43044C2ef86784.png",
      },
      {
        name: "Trust Wallet",
        symbol: "TWT",
        address: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x4B0F1812e5Df2A09796481Ff14017e6005508003.png",
      },
      {
        name: "UNCL on xDai on BSC",
        symbol: "UNCL",
        address: "0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0E8D5504bF54D9E44260f8d153EcD5412130CaBb/logo.png",
      },
      {
        name: "UniCrypt on xDai on BSC",
        symbol: "UNCX",
        address: "0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x09a6c44c3947B69E2B45F4D51b67E6a39ACfB506/logo.png",
      },
      {
        name: "Uniswap",
        symbol: "UNI",
        address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1.png",
      },
      {
        name: "Wrapped UST Token",
        symbol: "UST",
        address: "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x23396cF899Ca06c4472205fC903bDB4de249D6fC.png",
      },
      {
        name: "VAI Stablecoin",
        symbol: "VAI",
        address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png",
      },
      {
        name: "Wanaka Farm",
        symbol: "WANA",
        address: "0x339C72829AB7DD45C3C52f965E7ABe358dd8761E",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x339C72829AB7DD45C3C52f965E7ABe358dd8761E/logo.png",
      },
      {
        name: "WEYU",
        symbol: "WEYU",
        address: "0xFAfD4CB703B25CB22f43D017e7e0d75FEBc26743",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xFAfD4CB703B25CB22f43D017e7e0d75FEBc26743/logo.png",
      },
      {
        name: "WINk",
        symbol: "WIN",
        address: "0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99.png",
      },
      {
        name: "XRP Token",
        symbol: "XRP",
        address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://tokens.pancakeswap.finance/images/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE.png",
      },
      {
        name: "XWG",
        symbol: "XWG",
        address: "0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc/logo.png",
      },
      {
        name: "YAY Games",
        symbol: "YAY",
        address: "0x524dF384BFFB18C0C8f3f43d012011F8F9795579",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x524dF384BFFB18C0C8f3f43d012011F8F9795579/logo.png",
      },
      {
        name: "ZomaInfinity",
        symbol: "ZIN",
        address: "0xFbe0b4aE6E5a200c36A341299604D5f71A5F0a48",
        isNative: false,
        decimals: 18,
        chainId: 56,
        icon: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xFbe0b4aE6E5a200c36A341299604D5f71A5F0a48/logo.png",
      },
      {
        name: "SafeMoon",
        symbol: "SFM",
        address: "0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets.coingecko.com/coins/images/21863/thumb/photo_2021-12-22_14.43.36.jpeg?1696521217",
      },
      {
        name: "DogeBonk",
        symbol: "DOBO",
        address: "0xAe2DF9F730c54400934c06a17462c41C08a06ED8",
        isNative: false,
        decimals: 9,
        chainId: 56,
        icon: "https://assets.coingecko.com/coins/images/19153/thumb/dobo.png?1696518604",
      },
    ];
